import { Injectable } from '@angular/core';
import { IVehicleAddress } from '../interfaces/task-info';

enum DirectionsMode {
  Driving = 'driving',
  Walking = 'walking',
  Cycling = 'bicycling',
  PublicTransport = 'transit',
}

@Injectable({ providedIn: 'root' })
export class ExternalMapHelper {
  public openRouteDirections(from: IVehicleAddress, to: IVehicleAddress) {
    this.openDirections(from.latitude, from.longitude, to.latitude, to.longitude);
  }

  public openDirections(
    fromLat: number,
    fromLon: number,
    toLat: number,
    toLon: number,
    travelMode: DirectionsMode = DirectionsMode.Driving,
  ) {
    let url = `https://www.google.com/maps/dir/?api=1&travelmode=${travelMode}&origin=${fromLat},${fromLon}&destination=${toLat},${toLon}`;

    window.open(url, '_blank');
  }
}
